import { push } from "connected-react-router";
import moment from "moment";

import CSV from "csv-string";

import { toast } from "react-toastify";

import * as DatasetAPI from "api/DatasetAPI";

import * as foldersReducer from "containers/Folders/reducer";
import * as schemaMonitorReducer from "containers/SchemaMonitor/reducer";

import CSVIconWhite from "images/csv_white.svg";
import UploadCloudWhite from "images/cloud-plus-white.svg";

const UPDATE_FIELD = "dataSourceSummaries/UPDATE_FIELD";
const initialState = { dataSourceSummaries: {} };

export default function dataSourceSummariesReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getGlobal(state) {
  return state.dataSourceSummaries;
}

export function getIsLoading(state) {
  return getGlobal(state)?.isLoading;
}

export function getDataSourceSummaries(state) {
  return getGlobal(state)?.dataSourceSummaries;
}

export function getDataSourceSummary(state, folderId) {
  const summaries = getDataSourceSummaries(state)?.[folderId];

  return summaries
    ? summaries.map((ds) => {
        const schemaMonitor = schemaMonitorReducer.getSchemaMonitor(state, ds?.id);

        let icon =
          schemaMonitor !== undefined && schemaMonitorReducer.DATA_SOURCES
            ? schemaMonitorReducer.DATA_SOURCES.find((d) => d.value === schemaMonitor.type)?.iconWhite
            : undefined;

        if (icon === undefined) {
          if (ds.source_type === "RAW_DATA" && ds.name === "CSV Upload") {
            icon = CSVIconWhite;
          } else if (ds.source_type === "CONNECTION_METADATA" && ds.name === "Cloud Storage Link") {
            icon = UploadCloudWhite;
          }
        }

        return {
          ...ds,
          quality_high_count:
            ds?.readiness_score?.histogram?.counts === undefined
              ? 0
              : ds.readiness_score.histogram.counts.filter((c, i) => i > 6).reduce((a, b) => a + b, 0),
          quality_medium_count:
            ds?.readiness_score?.histogram?.counts === undefined
              ? 0
              : ds.readiness_score.histogram.counts.filter((c, i) => i >= 2 && i <= 6).reduce((a, b) => a + b, 0),
          quality_low_count:
            ds?.readiness_score?.histogram?.counts === undefined
              ? 0
              : ds.readiness_score.histogram.counts.filter((c, i) => i < 2).reduce((a, b) => a + b, 0),
          schema_monitor: schemaMonitor,
          fixed_dataset_count: Math.max(
            ds.missing_fixed_count,
            ds.outlier_count,
            ds.too_many_values_count,
            ds.unique_values_count
          ),
          icon: icon
        };
      })
    : [];
}

export function getCurrentDataSourceSummary(state) {
  const folderId = foldersReducer.getSelectedFolder(state);

  return getDataSourceSummary(state, folderId);
}

/* Actions */
export function updateIsLoading(isLoading) {
  return { type: UPDATE_FIELD, data: isLoading, key: "isLoading" };
}

export function updateDataSourceSummary(folderId, dataSourceSummary) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD,
      data: {
        ...getDataSourceSummaries(getState()),
        [folderId]: dataSourceSummary.map((ds) => {
          return {
            ...ds,
            total_datasets_evaluated: ds?.num_useful_variables?.histogram?.counts
              ? ds?.num_useful_variables?.histogram?.counts.reduce((a, b) => a + b, 0)
              : 0
          };
        })
      },
      key: "dataSourceSummaries"
    });
  };
}

export function fetchSummary() {
  return (dispatch, getState) => {
    dispatch(updateIsLoading(true));

    const folderId = foldersReducer.getSelectedFolder(getState());
    return DatasetAPI.getDataSourceSummaries(folderId).then((response) => {
      dispatch(updateDataSourceSummary(folderId, response));
      return dispatch(updateIsLoading(false));
    });
  };
}

export function init() {
  return (dispatch, getState) => {
    return dispatch(fetchSummary());
  };
}
